interface IGetFormattedNumberArgs {
  data: string;
  startSymbol?: string;
  endSymbol?: string;
  options?: Intl.NumberFormatOptions
}

export const getFormattedNumber = ({data, startSymbol = '', endSymbol = '', options}: IGetFormattedNumberArgs): string => {
  const formattedData = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    ...options
  }).format(+data);

  return `${startSymbol}${formattedData}${endSymbol}`;
}